import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/card/card.component.js'

const tagName = 'dap-ds-card'

/**
 * `dap-ds-card`
 * @summary A card is a container for content, actions, and images in a consistent format.
 * @element dap-ds-card
 * @title - Card
 *
 * @property {'sm' | 'md' | 'lg'} size - The size of the card. Default is `sm`.
 * @property {string} sizeMap - Responsive size map (e.g. "md:lg").
 *
 * @slot - The content of the card.
 *
 * @csspart base - The main card container.
 *
 * @cssproperty --dds-card-padding - The padding of the card. (default: var(--dds-spacing-400))
 * @cssproperty --dds-card-border-radius - The border radius of the card. (default: var(--dds-radius-large))
 * @cssproperty --dds-card-border-width - The border width of the card. (default: var(--dds-border-width-base))
 * @cssproperty --dds-card-border-color - The border color of the card. (default: var(--dds-border-neutral-divider))
 * @cssproperty --dds-card-background - The background color of the card. (default: var(--dds-background-neutral-base))
 * @cssproperty --dds-card-hover-border-color - The border color when hovering over the card. (default: var(--dds-border-brand-base))
 * @cssproperty --dds-card-active-border-color - The border color when the card is active. (default: var(--dds-border-brand-medium))
 * @cssproperty --dds-card-shadow - The box shadow of the card. (default: none)
 * @cssproperty --dds-card-hover-shadow - The box shadow when hovering over the card. (default: none)
 * @cssproperty --dds-card-transition-duration - The duration of the card's transitions. (default: var(--dds-transition-medium))
 * @cssproperty --dds-card-transition-timing - The timing function of the card's transitions. (default: var(--dds-easing-ease-in-out))
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSCard',
})

export default reactWrapper
